import { Modal } from "antd";
import { useForm } from "antd/es/form/Form";
import alert from "components/elements/Alert";
import dayjs from "dayjs";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { generateRandomString } from "utils/helper";
import * as services from "../services/payrollPeriodApi";
import { setEmploymentTypeOption, setIsLoading, setPayrollPeriodList, setStartPeriodOnFlowHr } from "../slices/payrollSlice";


function usePayrollPeriodCreate(props) {
    // const { isLoading = false, pagination = {}, payrollPeriodLists = [], visible = false } = props;
    const navigate = useNavigate();
    const [form] = useForm(null);
    const { t, i18n } = useTranslation();
    const dispatch = useDispatch();
    const { currentCompany, currentEmployee } = useSelector((state) => state.company);
    const { employmentTypeOption, startPeriodOnFlowHr, specialPeriodOption } = useSelector((state) => state.payroll);

    const [isModalOpen, setModalOpen] = useState(false);
    const [currentPayrollPeriod, setCurrentPayrollPeriod] = useState({});
    const payrollPeriodList = useSelector((state) => state.payroll.payrollPeriodList);

    const initialValues = useMemo(() => {
        return {
            ...currentPayrollPeriod,
            datePeriodDayjs: currentPayrollPeriod.startPeriod && currentPayrollPeriod.endPeriod
                ? [dayjs(currentPayrollPeriod.startPeriod), dayjs(currentPayrollPeriod.endPeriod)]
                : undefined,
            paymentDateDayjs: dayjs(currentPayrollPeriod?.paymentDate),
            extendDateDayjs: currentPayrollPeriod.offCyclePayrollStartDate && currentPayrollPeriod.offCyclePayrollEndDate
                ? [dayjs(currentPayrollPeriod.offCyclePayrollStartDate), dayjs(currentPayrollPeriod.offCyclePayrollEndDate)]
                : undefined,
            offCyclePayroll: currentPayrollPeriod?.offCyclePayroll === 'Y',
            lastModifiedName: currentPayrollPeriod?.updateBy
                ? (i18n.language === "en" ? currentPayrollPeriod?.updateBy?.nameEn + " " + currentPayrollPeriod?.updateBy?.surNameEn : currentPayrollPeriod?.updateBy?.name + " " + currentPayrollPeriod?.updateBy?.surName)
                : (i18n.language === "en" ? currentPayrollPeriod?.createBy?.nameEn + " " + currentPayrollPeriod?.createBy?.surNameEn : currentPayrollPeriod?.createBy?.name + " " + currentPayrollPeriod?.createBy?.surName),
            lastModifiedDate: currentPayrollPeriod?.updateBy
                ? (i18n.language === "en" ? dayjs(currentPayrollPeriod?.updateDate).format("DD MMM YYYY HH : mm") : dayjs(currentPayrollPeriod?.updateDate).add(543, "year").format("DD MMM YYYY HH : mm"))
                : (i18n.language === "en" ? dayjs(currentPayrollPeriod?.createDate).format("DD MMM YYYY HH : mm") : dayjs(currentPayrollPeriod?.createDate).add(543, "year").format("DD MMM YYYY HH : mm"))
        };

    }, [currentPayrollPeriod, i18n.language]);

    const onEdit = (record) => {
        const modifiedValues = {
            ...record,
            employmentTypeId: record?.employmentType.map(employmentType => i18n.language === "en" ? employmentType.nameEn : employmentType.name)
        }
        setCurrentPayrollPeriod({ ...modifiedValues })
        setModalOpen(true);
    }

    const handleOk = () => {
        setModalOpen(false)
    }

    const onCancel = useCallback(() => {
        setModalOpen(false);
    }, [])

    const handleCancel = () => {
        form.resetFields();
        navigate("/payroll", { state: { activeTab: "payrollAll" } });
    };

    const getPayrollPeriodList = useCallback(
        async ({ year } = {}) => {
            try {
                dispatch(setIsLoading(true));
                const values = {
                    requestId: generateRandomString(),
                    companyId: currentCompany,
                    year: year || 2024
                };
                const response = await services.getPayrollPeriodList(values);

                dispatch(setPayrollPeriodList(response.data?.content || []));
                console.log("log response", response);

            } catch (error) {
                alert({ type: "error", resultObject: error });
            } finally {
                dispatch(setIsLoading(false));
            }
        },
        [currentCompany, dispatch]
    );

    const getEmploymentType = useCallback(
        async (values) => {
            try {
                dispatch(setIsLoading(true));
                const values = {
                    requestId: generateRandomString(),
                    companyId: currentCompany,
                };
                const response = await services.employmentTypeOption(values);
                dispatch(setEmploymentTypeOption(response.data?.employmentTypeSetupList));

            } catch (error) {
                alert({ type: "error", resultObject: error });
            } finally {
                dispatch(setIsLoading(false));
            }
        },
        [currentCompany, dispatch]
    );

    const getStartPerionOnFlowHr = useCallback(
        async (params) => {
            try {
                console.log("log params", params);

                dispatch(setIsLoading(true));
                const values = {
                    paymentPeriodType: params.paymentPeriodType || "1",
                    firstDateOfTheYear: params.startOfFirstPeriod?.format("YYYY-MM-DD"),
                    year: params.taxYear?.format("YYYY"),
                    companyId: currentCompany
                };
                const response = await services.startPeriodOnFlowHr(values);
                dispatch(setStartPeriodOnFlowHr(response.data));

            } catch (error) {
                alert({ type: "error", resultObject: error });
            } finally {
                dispatch(setIsLoading(false));
            }
        },
        [currentCompany, dispatch]
    );


    function employmentTypeDropdown() {
        return employmentTypeOption?.map((o, index) => {
            return { label: o.employmentTypeName, value: o.id }
        })
    }

    const startOnFlowHrDropdown = useCallback(
        () => {
            console.log("i18n.language", i18n.language);

            return startPeriodOnFlowHr?.map((o, index) => {
                return { ...o, label: o?.["name" + (i18n.language == 'en' ? "En" : "")], value: o.index }
            })
        },
        [i18n.language, startPeriodOnFlowHr],
    )


    const createPayrollPeriod = useCallback(
        async (values = {}) => {
            try {
                function paymentPeriodType() {
                    if (values.paymentPeriodType == "4") {
                        return {
                            paymentPeriodTypeWeek: {
                                paymentDay: values.paymentDay?.toUpperCase()
                            }
                        };
                    } else {
                        return {
                            ["paymentPeriodType" + values.paymentPeriodType]: {
                                paymentDate: values.paymentDate,
                                firstPaymentPeriod: values.firstPaymentPeriod,
                                inMonth: values.inMonth,
                                secondPaymentPeriod: values.secondPaymentPeriod,
                                inSecondMonth: values.inSecondMonth,
                                thirdPaymentPeriod: values.thirdPaymentPeriod,
                                nextMonth: values.nextMonth
                            }
                        };
                    }
                }

                let json = {
                    requestId: generateRandomString(),
                    companyId: currentCompany,
                    employeeId: currentEmployee,
                    actionId: currentEmployee,
                    employmentType: values.employmentType,
                    paymentPeriodType: values.paymentPeriodType,
                    year: values?.taxYear?.format("YYYY"),
                    firstDateOfTheYear: values.startOfFirstPeriod?.format("YYYY-MM-DD"),
                    index: values.startPeriodOnFlowHr,
                    ...paymentPeriodType(),
                    allowPayBeforeHoliday: values.allowPayBeforeHoliday,
                    offCyclePayroll: values.offCyclePayroll ? "Y" : "N",
                    offCyclePayrollStartDate: values.startCalculateOffCycle,
                    socialSprint: values.socialSprint ? values.socialSprint : null
                };
                console.log("json", json);

                let res = await services.createPayrollPeriod(json);
                console.log("res.data?.stauts", res);

                dispatch(setIsLoading(true));
                alert({ type: "success" });
                onCancel();
                navigate("/payroll", { state: { activeTab: "payrollAll" } });
            } catch (error) {
                alert({ type: "error", resultObject: error, noti: true });
            } finally {
                dispatch(setIsLoading(false));
            }
        },
        [currentCompany, currentEmployee, dispatch, navigate, onCancel]
    );

    const onSubmit = useCallback(
        (values) => {
            Modal.confirm({
                title: t("dialog.confirmation.header"),
                content: (
                    <>
                        <p>
                            {t("dialog.confirmation.create").replace("{entity}", t("payment_period.label.payment_period"))}

                        </p>
                    </>
                ),
                onOk() {
                    createPayrollPeriod(values);
                },
                okText: t("common.confirm").toUpperCase(),
                cancelText: t("common.cancel").toUpperCase(),
            });
        },
        [t, createPayrollPeriod, navigate]
    );

    const updatePayrollPeriod = useCallback(
        async (values) => {
            try {
                dispatch(setIsLoading(true));
                const editPayroll = {
                    requestId: generateRandomString(),
                    companyId: currentCompany,
                    employeeId: currentEmployee,
                    actionId: currentEmployee,
                    payrollPeriodId: values?.id,
                    startPeriod: values?.startPeriod,
                    endPeriod: values?.endPeriod,
                    paymentDate: values?.paymentDateDayjs.format("YYYY-MM-DD"),
                    offCyclePayroll: values?.offCyclePayroll ? "Y" : "N",
                    offCyclePayrollStartDate: values?.offCyclePayrollStartDate,
                    offCyclePayrollEndDate: values?.offCyclePayrollEndDate
                };
                await services.updatePayrollPeriod(editPayroll);

                getPayrollPeriodList(dayjs().format("YYYY"));
                alert({ type: "success" });
                form.resetFields()
                onCancel();
            } catch (error) {
                console.log("error", error);
                alert({ type: "error", resultObject: error });
            } finally {
                dispatch(setIsLoading(false));
            }
        }, [currentCompany, currentEmployee, dispatch, form, getPayrollPeriodList, onCancel]
    );

    const onEditSubmit = useCallback(
        (values) => {
            Modal.confirm({
                title: t("dialog.confirmation.header"),
                content: (
                    <>
                        <p>
                            {t("dialog.confirmation.edit").replace("{entity}", t("payment_period.label.payment_period"))}

                        </p>
                    </>
                ),
                onOk() {
                    updatePayrollPeriod(values);
                },
                okText: t("common.confirm").toUpperCase(),
                cancelText: t("common.cancel").toUpperCase(),
            });
        },
        [t, updatePayrollPeriod]
    );

    useEffect(() => {
        if (currentCompany) {
            getEmploymentType();
        }
    }, [currentCompany, getEmploymentType]);

    useEffect(() => {
        if (currentCompany) {
            getPayrollPeriodList(dayjs().format("YYYY"));
        }
    }, [currentCompany]);

    return {
        employmentTypeOption,
        isModalOpen,
        payrollPeriodList,
        currentPayrollPeriod,
        initialValues,
        form,
        employmentTypeDropdown,
        startOnFlowHrDropdown,
        getStartPerionOnFlowHr,
        updatePayrollPeriod,
        onSubmit,
        onCancel,
        onEdit,
        getPayrollPeriodList,
        handleCancel,
        onEditSubmit,
        handleOk,
        // visible
    }
}

export default usePayrollPeriodCreate;